export default __webpack_public_path__ + "static/media/img_5.5a44d979.jpg";